import { useTranslation } from 'react-i18next';
import { MainLayout } from '@/components/layout/MainLayout';
import { PageHeader } from '@/components/layout/PageHeader';
import { UserMenu } from '@/components/common/UserMenu';
import { EmptyState } from '@/components/common/EmptyState';

/**
 * Configurações do prestador (acedida pela engrenagem no rodapé da sidebar).
 * Placeholder por agora — espaço reservado para futuras opções de configuração.
 * O perfil/foto vive em `/meu-perfil` (clicando no nome no canto sup. direito).
 */
export default function ConfiguracoesPrestador() {
  const { t } = useTranslation();

  return (
    <MainLayout>
      <div className="p-6 flex flex-col gap-5">
        <PageHeader titulo={t('prestadorSettings.title')} acoes={<UserMenu />} />
        <EmptyState
          titulo={t('prestadorSettings.emptyTitle')}
          descricao={t('prestadorSettings.emptyDescription')}
        />
      </div>
    </MainLayout>
  );
}
